import { Product, Application } from '../types';

export const DEFAULT_PRODUCTS: Product[] = [
  {
    id: 'prod-1',
    name: 'Raaghu',
    description: 'AI Powered Web App Development Platform with Design System',
    createdAt: new Date().toISOString()
  },
  {
    id: 'prod-2',
    name: 'AI Pundit',
    description: 'Developer Velocity Service that leverages machine learning (ML), artificial intelligence (AI) and automation to provide a wide range of innovative solutiions',
    createdAt: new Date().toISOString()
  }
];

export const DEFAULT_APPLICATIONS: Application[] = [
  {
    id: 'app-1',
    name: 'Raaghu Design System',
    productId: 'prod-1',
    githubRepoUrl: 'https://github.com/Wai-Technologies/raaghu-react',
    githubProjectsUrl: 'https://github.com/orgs/Wai-Technologies/projects/16/views/2',
    applicationUrls: [
      { name: 'Storybook', url: 'https://react.raaghu.ai' },
      { name: 'Figma', url: 'https://www.figma.com/community/file/1425066439193737902/raaghu-design-system-kit' },
      { name: 'Website', url: 'https://www.waiin.com' },
      { name: 'Documentation', url: 'https://docs.waiin.com' }
    ],
    releases: [],
    createdAt: new Date().toISOString()
  },
  {
    id: 'app-2',
    name: 'AI Pundit Magic',
    productId: 'prod-2',
    githubRepoUrl: 'https://github.com/AI-Pundit/AI-Pundit-Magic',
    githubProjectsUrl: 'https://github.com/orgs/AI-Pundit/projects/9',
    applicationUrls: [
      { name: 'VS Code Marketplace', url: 'https://marketplace.visualstudio.com/items?itemName=Waiin.pundit-magic' },
      { name: 'Open VSX', url: 'https://open-vsx.org/extension/Waiin/pundit-magic' },
      { name: 'Documentation', url: 'https://docs.waiin.com' }
    ],
    releases: [],
    createdAt: new Date().toISOString()
  },
  {
    id: 'app-3',
    name: 'AI Pundit Flow',
    productId: 'prod-2',
    githubRepoUrl: 'https://github.com/AI-Pundit/AI-Pundit-Flow',
    githubProjectsUrl: 'https://github.com/orgs/AI-Pundit/projects/8',
    applicationUrls: [
      { name: 'Figma Plugin', url: 'https://www.figma.com/community/plugin/1522857642317817498/ai-pundit-flow' },
      { name: 'Documentation', url: 'https://docs.waiin.com' }
    ],
    releases: [],
    createdAt: new Date().toISOString()
  },
  {
    id: 'app-4',
    name: 'Wai Platform',
    productId: 'prod-2',
    githubRepoUrl: 'https://github.com/Wai-Technologies/wai-platform',
    githubProjectsUrl: 'https://github.com/orgs/Wai-Technologies/projects/11',
    applicationUrls: [
      { name: 'Web App', url: 'https://platform.waiin.com' }
    ],
    releases: [],
    createdAt: new Date().toISOString()
  }
];
